const zeroPaddedSequenceNumber = (val: number | string): string => {
  const valStr = `${val}`
  return valStr.length === 1 ? `0${valStr}` : valStr
}

export {zeroPaddedSequenceNumber}
